export const AUTH_TOKEN = 'auth-token-new';
export const EXPIRATION_TIME = 'expiration-time';
